import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import classnames from 'classnames'

const DESCRIPTION_HEIGHT = 80;

const useClasses = makeStyles(({ palette}) => ({
    root: {
        margin: '0 0 0 20px'
    },
    fullHeader: {
        width: '100%',
        whiteSpace: 'nowrap'
    },
    headerComponent: {
        flex: 1,
        height: '100%'
    },
    categoryDescription: {
        margin: '0 0 0 20px',
        fontSize: '0.89em',
        minHeight: DESCRIPTION_HEIGHT,
        maxHeight: DESCRIPTION_HEIGHT
    }
}))

const TocColumn = ({ header, children, excerpt }) => {
    const _classes = useClasses()

    return (
        <div className={_classes.root}>
            <div className={classnames(_classes.fullHeader)}>
                <div className={classnames(_classes.headerComponent)}>
                    {header}
                </div>
            </div>
            <div className={classnames(_classes.categoryDescription)}>
                {excerpt}
            </div>
            <div>
                {children}
            </div>
        </div>
    )
}

export default TocColumn
